import React from "react";
import { useParams } from "react-router-dom";
import { useParkDetailQuery } from "../../generated/graphql";
import ImageSlider from "../utils/ImageSlider";

function ParkDetail() {
  const { parkCode } = useParams<any>();

  const { loading, data, error } = useParkDetailQuery({
    variables: {
      parkCode: parkCode,
    },
  });

  if (loading) {
    return <div>Loading ...</div>;
  }

  if (error) {
    return <div>Error</div>;
  }

  return (
    <div className="flex items-center justify-center">
      <div className="w-5/6 relative mt-4">
        <p className="text-4xl font-sans text-gray-800 font-semibold tracking-tight text-center p-2">
          {data?.park?.fullName}
        </p>
        <p className="text-center font-semibold">
          States : {data?.park?.states}
        </p>
        <div className="flex items-center justify-center">
          <div className="w-auto md:w-3/4 py-4">
            <p className="text-justify">{data?.park.description}</p>
          </div>
        </div>
        <ImageSlider imageUrls={data?.park?.images} />
        <DisplayTemplate title="Weather">
          <p className="text-justify">{data?.park.weatherInfo}</p>
        </DisplayTemplate>
      </div>
    </div>
  );
}

type DisplayTemplateProps = {
  title?: String | undefined | null;
  children: any;
};
function DisplayTemplate({ title, children }: DisplayTemplateProps) {
  return (
    <div className="flex items-center justify-center pb-8">
      <div className="w-auto md:w-3/4 p-4 bg-gray-100 rounded-md">
        <p className="text-xl sm:text-4xl lg:text-5xl leading-none font-bold text-gray-900 tracking-tight mb-4">
          {title !== undefined && title}
        </p>
        {children}
      </div>
    </div>
  );
}

export default ParkDetail;
